import { Countdown } from "../../atoms/DependencyHelper";
import PropTypes from "prop-types";

const Timer = ({ onTimerComplete, dateTime, preText, className }) => {
  const handleChange = (event) => {
    onTimerComplete(event);
  };
  const renderer = (props) => {
    if (props.completed) {
      handleChange(false);
      return <></>;
    } else {
      handleChange(true);
      return (
        <div className={className}>

          { !!preText &&
          
            <span>{preText}</span>
          }

          <span>{props.formatted.days}</span>
          <span>d </span>
          <span>{props.formatted.hours}</span>
          <span>h </span>
          <span>{props.formatted.minutes}</span>
          <span>m </span>
          <span>{props.formatted.seconds}</span>
          <span>s</span>
        </div>
      );
    }
  };

    return (
        <Countdown
          date={dateTime}
          renderer={renderer}
          zeroPadTime={1}
        />
    );
};

Timer.propTypes = {
  onTimerComplete: PropTypes.func,
  dateTime: PropTypes.string,
};

export default Timer;
